const isInvalid = ({ workshopStatus }) => `${workshopStatus || ''}` === 'N'

export default (that) => [
  {
    text: that.$l('btn_edit') || '编辑',
    icon: 'el-icon-edit',
    menuType: 'edit',
    allow: 'E',
    disabled: (row) => isInvalid(row),
  },
  {
    text: that.$l('btn_delete') || '删除',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: true,
    allow: 'D',
    disabled: (row) => isInvalid(row),
  },
]
